import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./App.layout";
import Dashboard from './pages/Dashboard';
import Programs from './pages/Programs';
import Schedule from './pages/Schedule';
import Wallet from './pages/Wallet';
import Account from './pages/Account';
import LearnAboutUs from './pages/LearnAboutUs';
import Explore from './pages/Explore';
import JoinTheFun from './pages/JoinTheFun';
import ParentProfile from './pages/ParentProfile';
import ChildProfile from './pages/ChildProfile';
import PaymentHistrory from './pages/PaymentHistrory';
import HelpSupport from "./pages/HelpSupport";
import Login from './pages/Login';
import Signup from "./pages/Signup";
import Course from "./pages/Course";
import PickList from "./pages/pickAList";
import Teachers from "./pages/Teachers";
import TeacherDetails from "./pages/TeacherDetails";
import ViewChildProfile from "./pages/ViewChildProfile";
import ProgressReport from "./pages/ProgressReport";
import ProtectedRoute from "./ProtectedRoute"; // Import ProtectedRoute
import Cart from "./pages/CartList";
import FacilityPlans from "./pages/FacilityPlan";
import AllocatedClasessAll from "./pages/AllocatedClasses";
import AttendanceTeacher from "./pages/AttendanceTeacher";
import Attendance from "./pages/Attendance";
import TeacherFeedback from "./pages/TeacherFeedback";
import PersonalProfile from "./pages/PersonalProfile";
import PublicProfile from "./pages/PublicProfile";
import TeacherDashboard from "./pages/TeacherDashboard";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ChangePassword from "./pages/ChangePassword";
import NotFound404 from './config/NotFound404';
import EmailVerifySuccess from "./pages/Email/EmailVerifySuccess";
import EmailVerifyFailed from "./pages/Email/EmailVerifyFailed";

const AppRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signUp" element={<Signup />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/resetPassword" element={<ResetPassword />} />
            <Route path="/emailVerifySuccess" element={<EmailVerifySuccess />} />
            <Route path="/emailVerifyFailed" element={<EmailVerifyFailed />} />

            {/* Parent Routes */}
            <Route element={<ProtectedRoute allowedRoles={['Parent']} />}>
                <Route element={<Layout />}>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/programs" element={<Programs />} />
                    <Route path="/schedule" element={<Schedule />} />
                    <Route path="/wallet" element={<Wallet />} />
                    <Route path="/learn_about_us" element={<LearnAboutUs />} />
                    <Route path="/explore" element={<Explore />} />
                    <Route path="/joinTheFun" element={<JoinTheFun />} />
                    <Route path="/parentProfile" element={<ParentProfile />} />
                    <Route path="/childProfile" element={<ChildProfile />} />
                    <Route path="/childProfile/:id" element={<ChildProfile />} />
                    <Route path="/paymentHistory" element={<PaymentHistrory />} />
                    <Route path="/course/:id" element={<Course />} />
                    <Route path="/pickList/:id" element={<PickList />} />
                    <Route path="/teachers/:id" element={<Teachers />} />
                    <Route path="/teacherDetails/:id" element={<TeacherDetails />} />
                    <Route path="/viewChildProfile" element={<ViewChildProfile />} />
                    <Route path="/progressReport/:id" element={<ProgressReport />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/facilityPlan" element={<FacilityPlans />} />
                    <Route path="/changePassword" element={<ChangePassword />} />
                    <Route path="*" element={<NotFound404 />} />
                </Route>
            </Route>

            {/* Teacher Routes */}
            <Route element={<ProtectedRoute allowedRoles={['Teacher']} />}>
                <Route element={<Layout />}>
                    <Route path="/teacherDashboard" element={<TeacherDashboard />} />
                    <Route path="/allocatedClasses" element={<AllocatedClasessAll />} />
                    <Route path="/attendanceTeacher/:id" element={<AttendanceTeacher />} />
                    <Route path="/attendance" element={<Attendance />} />
                    <Route path="/teacherFeedback" element={<TeacherFeedback />} />
                    <Route path="/personalProfile" element={<PersonalProfile />} />
                    <Route path="/publicProfile" element={<PublicProfile />} />
                    <Route path="*" element={<NotFound404 />} />
                </Route>
            </Route>

            {/* Common Routes for both roles */}
            <Route element={<ProtectedRoute allowedRoles={['Parent', 'Teacher']} />}>
                <Route element={<Layout />}>
                    <Route path="/account" element={<Account />} />
                    <Route path="/helpSupport" element={<HelpSupport />} />
                    <Route path="/changePassword" element={<ChangePassword />} />
                </Route>
            </Route>
        </Routes>
    );
};

export default AppRouter;
